<template>
  <div class="animated fadeIn col-md-12">
    <SearchCard
      :filterCatch="true"
      :hasFilter="true"
      :title="$lang.ticketLang.search_ticket_access"
      :url="url"
      :html="false"
      ref="searchCard"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="showModal"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          cols="12"
          class="py-1 mb-3 border-bottom d-md-flex d-block align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <span
              class="mr-1 fs_1_3rem w_h_35 border bg-light rounded-circle d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-user text-primary" />
            </span>
            <b class="px-1 fs_1rem" v-html="generateTitle(item)" />
          </div>
          <small
            class="text-muted d-md-block d-flex align-items-center justify-content-between"
          >
            <div
              v-b-tooltip
              title="ثبت کننده"
              v-if="
                pathOr(null, ['created_by'], item) &&
                pathOr(null, ['created_by'], item) !== getFullName(item)
              "
            >
              <i class="fas fa-user mr-1" />
              <span v-text="pathOr('', ['created_by'], item)" />
            </div>
            <div v-b-tooltip title="زمان ایجاد">
              <i class="fas fa-clock mr-1" />
              <span v-text="pathOr('', ['created_at', 'jalali'], item)" />
            </div>
          </small>
        </b-col>
        <b-col cols="12" md="12">
          <b-row>
            <b-col cols="12" md="" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <strong v-text="$lang.ticketLang.ticket_supporter" />:
              <span class="text-muted" v-text="getFullName(item)" />
            </b-col>
            <b-col cols="12" md="" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <strong v-text="$lang.ticketLang.parvande_number" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['parvandeh', 'parvandeh_number'], item)"
              />
            </b-col>
            <b-col cols="12" md="" class="py-1">
              <i class="far fa-check-circle mr-1" />
              <strong v-text="$lang.ticketLang.ticket_page.national_code" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['parvandeh', 'national_code'], item)"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="py-1"
              v-if="pathOr('', ['expire_at'], item)"
            >
              <i class="far fa-check-circle mr-1" />
              <strong v-text="$lang.ticketLang.expire_at" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['expire_at', 'jalali'], item)"
              />
            </b-col>
            <b-col
              cols="12"
              class="py-1"
              v-if="pathOr(null, ['ticket_status'], item)"
            >
              <i class="far fa-check-circle mr-1" />
              <strong v-text="$lang.ticketLang.ticket_show_status" />:
              <b-badge
                v-for="status in pathOr([], ['ticket_status'], item)"
                :key="status.id"
                variant="primary"
                class="mr-2"
              >
                <i class="fas fa-tag mr-1" />
                <span v-text="status.caption" />
              </b-badge>
            </b-col>
            <b-col
              cols="12"
              md="8"
              class="py-1"
              v-if="pathOr([], ['ticket_unit'], item).length"
            >
              <i class="far fa-check-circle mr-1" />
              <strong v-text="'واحد بررسی کننده'" />:
              <b-badge
                v-for="unit in pathOr([], ['ticket_unit'], item)"
                :key="unit.id"
                variant="success"
                class="mr-2"
              >
                <i class="fas fa-tag mr-1" />
                <span v-text="unit.caption" />
              </b-badge>
            </b-col>
            <b-col
              cols="12"
              class="py-1"
              v-if="pathOr(null, ['description'], item)"
            >
              <i class="far fa-check-circle mr-1" />
              <strong v-text="$lang.ticketLang.description" />:
              <span
                class="text-muted"
                v-text="pathOr('', ['description'], item)"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="12" class="py-1 mt-3 border-top">
          <b-row align-v="center" align-h="between" class="w-100 m-0">
            <b-col cols="12" md="auto" class="px-0" />
            <b-col cols="12" md="" class="text-right px-0">
              <b-button
                v-if="isAdmin(permissions)"
                class="m-1"
                size="sm"
                variant="outline-success"
                @click="showModal('edit', item.id)"
              >
                <i class="fas fa-edit mr-1" />
                {{ $lang.edit }}
              </b-button>
              <b-button
                v-if="isAdmin(permissions)"
                class="m-1"
                size="sm"
                variant="outline-danger"
                @click="showConfirm(item.id)"
              >
                <i class="fas fa-trash mr-1" />
                {{ $lang.remove }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="modal"
      size="lg"
      ok-only
      hide-footer
      hide-header
    >
      <Add
        v-if="modalMode === 'add'"
        :parentPermissions="permissions"
        @close="modal = false"
        @getData="getData"
      />
      <Edit
        v-if="modalMode === 'edit'"
        :parentPermissions="permissions"
        :id="currentId"
        @close="modal = false"
        @getData="getData"
      />
    </b-modal>
    <Confirm
      v-model="confirm"
      :title="$lang.ticketLang.delete_ticket_access"
      :description="$lang.ticketLang.are_you_sure_for_delete"
      dynamicClass=""
      :loading="loading"
      :preventDefault="true"
      @cancel="confirm = false"
      @ok="remove"
    />
  </div>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import Add from "./add.vue";
import Edit from "./edit.vue";
import { pathOr, includes } from "ramda";
import Confirm from "@/components/base/confirm";
import { isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "ticket-access-search",
  inject: ["ticketAccessRepository"],
  components: {
    SearchCard,
    Add,
    Edit,
    Confirm,
  },
  data() {
    return {
      modal: false,
      modalMode: "add",
      permissions: [],
      confirm: false,
      loading: false,
      currentId: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["ticket", "ticket_access"]);
    },
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    updatePermissions(data) {
      this.permissions = [...data];
    },
    showConfirm(id) {
      this.currentId = id;
      this.confirm = true;
    },
    showModal(mode = "add", id = null) {
      this.currentId = id;
      this.modalMode = mode;
      this.modal = true;
    },
    getData() {
      this.$refs.searchCard.getItems();
    },
    generateTitle(item) {
      const parvandehNumber = pathOr(
        "",
        ["parvandeh", "parvandeh_number"],
        item
      );
      const personFullName = pathOr(
        "",
        ["parvandeh", "person_full_name"],
        item
      );
      const nationalCode = pathOr("", ["parvandeh", "national_code"], item);
      return `${parvandehNumber} - ${personFullName} - ${nationalCode}`;
    },

    getFullName(item) {
      return pathOr("", ["parvandeh", "person_full_name"], item);
    },
    async remove() {
      try {
        this.loading = true;
        const id = this.currentId;
        const response = await this.ticketAccessRepository.delete(id);
        this.$notify.success(response.data.message);
        this.confirm = false;
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
